export default "__VITE_ASSET__DSKFrboG__"